import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import api from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const [s, setS] = useState(null);
  const { logo } = useSettings();
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  return (
    <footer data-testid="footer" className="bg-choco text-cream/80 mt-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img src={logo} alt="Nel Bake House" className="h-16 w-16 rounded-full object-cover mb-3" />
          <span className="font-display text-2xl font-bold text-cream block">NEL BAKE HOUSE</span>
          <p className="text-[11px] uppercase tracking-[0.25em] text-gold mt-1">Healthy & No Preservatives</p>
          <p className="text-sm mt-5 leading-relaxed text-cream/60">
            Freshly baked goodness made with quality ingredients and no preservatives.
          </p>
        </div>

        <div>
          <h4 className="text-cream font-semibold mb-4 text-sm uppercase tracking-wider">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-gold transition-colors">Shop</Link></li>
            <li><Link to="/shop" className="hover:text-gold transition-colors">Categories</Link></li>
            <li><Link to="/track-order" className="hover:text-gold transition-colors">Track Order</Link></li>
            <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-cream font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-cream font-semibold mb-4 text-sm uppercase tracking-wider">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            {s && (
              <>
                <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-gold" />{s.contact_phone}</li>
                <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-gold" />{s.contact_email}</li>
                <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-gold" />{s.contact_address}</li>
                <li>
                  <a href={s.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-gold transition-colors">
                    <Instagram size={16} className="text-gold" /> Follow us
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-cream/50">
          <span>© {new Date().getFullYear()} Nel Bake House. All rights reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-gold transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
